import { routeUtil, SubNavigation } from '@cmg/common';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Routes, useParams } from 'react-router-dom';

import routeFactory from '../../common/util/routeFactory';
import type { UUID } from '../../types/common';
import { selectFirmDisplayName } from './firm-detail/ducks';

const mapStateToProps = state => ({
  firmDisplayName: selectFirmDisplayName(state),
});

type Props = ReturnType<typeof mapStateToProps>;
type RolodexFirmBreadcrumbRouteParams = { firmId: UUID };

export const RolodexFirmBreadcrumbComponent: React.FC<Props> = ({ firmDisplayName }) => {
  const { firmId } = useParams<RolodexFirmBreadcrumbRouteParams>();

  return (
    <React.Fragment>
      {firmDisplayName && firmId && (
        <SubNavigation.Breadcrumb>
          <SubNavigation.Link end to={routeFactory.rolodexFirmDetail.getUrlPath({ firmId })}>
            {firmDisplayName.value}
          </SubNavigation.Link>
        </SubNavigation.Breadcrumb>
      )}
    </React.Fragment>
  );
};

const ConnectedFirmBreadcrumb = connect(mapStateToProps)(RolodexFirmBreadcrumbComponent);

export const CreateFirmBreadcrumbComponent = () => (
  <SubNavigation.Breadcrumb>
    <SubNavigation.Link to={routeFactory.rolodexFirmCreate.getUrlPath()}>
      New Organization
    </SubNavigation.Link>
  </SubNavigation.Breadcrumb>
);

export const ImportFirmBreadcrumbComponent = () => (
  <SubNavigation.Breadcrumb>
    <SubNavigation.Link to={routeFactory.rolodexFirmImport.getUrlPath()}>
      New Organization
    </SubNavigation.Link>
  </SubNavigation.Breadcrumb>
);

/**
 * Displays the firm's name as a route link to the firm/organization route, or
 * "New Organization" on the Create Org routes.
 *
 * Used within Rolodex sub nav.
 */
const rel = (routePath: string) =>
  routeUtil.getRelativeRoutePath(routeFactory.rolodex.routePath, routePath);

const RolodexFirmBreadcrumb = () => {
  return (
    <Routes>
      <Route
        path={rel(routeFactory.rolodexFirmDetail.routePath)}
        element={<ConnectedFirmBreadcrumb />}
      />
      <Route
        path={rel(routeFactory.rolodexFirmCreate.routePath)}
        element={<CreateFirmBreadcrumbComponent />}
      />
      <Route
        path={rel(routeFactory.rolodexFirmImport.routePath)}
        element={<ImportFirmBreadcrumbComponent />}
      />
    </Routes>
  );
};

export default RolodexFirmBreadcrumb;
